/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_AccesosMovilidad as AccesosMovilidad,
  rec_CatalogosMovilidad as CatalogosMovilidad,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_JSXRuntime as JSXRuntime,
  rec_PedidosMovilidadAdmin as PedidosMovilidadAdmin,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_puedeRutaAdmin as puedeRutaAdmin,
  rec_rZ as rZ,
} from "../../runtime/index.jsx";
export function MovilidadAdmin() {
  let e = (0, ReactCompiler.c)(16),
    [t, n] = (0, React.useState)(`pedidos`);
  if (!puedeRutaAdmin(`/admin/movilidad`)) {
    let t;
    return (
      e[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[0] = t))
        : (t = e[0]),
      t
    );
  }
  let r;
  e[1] === t
    ? (r = e[2])
    : ((r = rZ.map((e) => (
        <button
          key={e.id}
          type={`button`}
          onClick={() => n(e.id)}
          className={`-mb-px border-b-2 px-3 py-2 text-sm transition ${t === e.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
          children={e.label}
        />
      ))),
      (e[1] = t),
      (e[2] = r));
  let i;
  e[3] === r
    ? (i = e[4])
    : ((i = (
        <div
          className={`flex flex-wrap gap-1 border-b border-(--border)`}
          children={r}
        />
      )),
      (e[3] = r),
      (e[4] = i));
  let a;
  e[5] === t
    ? (a = e[6])
    : ((a = t === `pedidos` && <PedidosMovilidadAdmin />),
      (e[5] = t),
      (e[6] = a));
  let o;
  e[7] === t
    ? (o = e[8])
    : ((o = t === `accesos` && <AccesosMovilidad />), (e[7] = t), (e[8] = o));
  let s;
  e[9] === t
    ? (s = e[10])
    : ((s = t === `configuracion` && <CatalogosMovilidad />),
      (e[9] = t),
      (e[10] = s));
  let c;
  return (
    e[11] !== i || e[12] !== a || e[13] !== o || e[14] !== s
      ? ((c = (
          <EstructuraPrincipal
            title={`Movilidad`}
            children={
              <div className={`flex flex-col gap-4`} children={[i, a, o, s]} />
            }
          />
        )),
        (e[11] = i),
        (e[12] = a),
        (e[13] = o),
        (e[14] = s),
        (e[15] = c))
      : (c = e[15]),
    c
  );
}
